/* eslint-disable no-undef */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
/*import Home from './pages/Home';*/
import ModernNavbar from './components/ModernNavbar';
import ModernLogin from './screens/ModernLogin';
import ModernRegistration from './screens/ModernRegistration';
import ModernHome from './screens/ModernHome';
import ModernProfile from './screens/ModernProfile';
import ModernBeneficiaries from './screens/ModernBeneficiaries';
import ModernCalendar from './screens/ModernCalendar';
import ModernPay from './screens/ModernPay';
import ModernPQRS from './screens/ModernPQRS';
import UsersList from './screens/UsersList';
import AdminTasks from './screens/AdminTasks';
import DoctorManagementDashboard from './screens/DoctorManagementDashboard';
import { Alert } from '@mui/material';
import { useAlert } from './AlertContext';

const SecureRoute = ({ children }) => {
  const session = localStorage.getItem('session');

  if (session) {
    return children;
  } else {
    window.location.pathname = '/login';
  }
};

const AppRoutes = () => {
  const noNav = ['/login', '/register'];
  const session = localStorage.getItem('session');
  const session_data = session && JSON.parse(session);
  const { alert } = useAlert();

  return (
    <Router basename={'/'}>
      {!noNav.some((item) => window.location.pathname.startsWith(item)) && (
        <ModernNavbar is_admin={session && session_data.is_admin} />
      )}
      {alert && (
        <Alert
          sx={{
            position: 'absolute',
            bottom: '32px',
            right: '32px',
            p: 2,
            width: 'fit-content',
            zIndex: 9999,
          }}
          severity={alert.type || 'info'}
        >
          {alert.message}
        </Alert>
      )}
      <Routes>
        <Route path="/login" element={<ModernLogin />} />
        <Route path="/register" element={<ModernRegistration />} />

        <Route
          path="/"
          element={
            <SecureRoute>
              <ModernHome />
            </SecureRoute>
          }
        />
        <Route
          path="/calendar"
          element={
            <SecureRoute>
              <ModernCalendar />
            </SecureRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <SecureRoute>
              <ModernProfile />
            </SecureRoute>
          }
        />
        <Route
          path="/pay"
          element={
            <SecureRoute>
              <ModernPay />
            </SecureRoute>
          }
        />
        <Route
          path="/pay/success"
          element={
            <SecureRoute>
              <ModernPay success={true} />
            </SecureRoute>
          }
        />
        <Route
          path="/pay/failed"
          element={
            <SecureRoute>
              <ModernPay failed={true} />
            </SecureRoute>
          }
        />
        <Route
          path="/pay/pending"
          element={
            <SecureRoute>
              <ModernPay pending={true} />
            </SecureRoute>
          }
        />
        <Route
          path="/beneficiaries"
          element={
            <SecureRoute>
              <ModernBeneficiaries />
            </SecureRoute>
          }
        />
        <Route
          path="/pqrsdf"
          element={
            <SecureRoute>
              <ModernPQRS />
            </SecureRoute>
          }
        />

        <Route
          path="/admin-users"
          element={
            <SecureRoute>
              <UsersList />
            </SecureRoute>
          }
        />
        <Route
          path="/admin-tasks"
          element={
            <SecureRoute>
              <AdminTasks />
            </SecureRoute>
          }
        />
        <Route
          path="/admin-doctors"
          element={
            <SecureRoute>
              <DoctorManagementDashboard />
            </SecureRoute>
          }
        />
        <Route
          path="/admin-register"
          element={
            <SecureRoute>
              <ModernRegistration />
            </SecureRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <div ref={() => (window.location.href = '/privacy_policy.html')} />
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
